import { ButtonDocs } from "./docs/ButtonDocs";
import { ColorDocs } from "./docs/ColorDocs";
import { FormFieldDocs } from "./docs/FormFieldDocs";
import { FormManagerDocs } from "./docs/FormManagerDocs";
import { FormPageDocs } from "./docs/FormPageDocs";
import { InputDocs } from "./docs/InputDocs";
import { TableDocs } from "./docs/TableDocs";
import { TypographyDocs } from "./docs/TypographyDocs";
import type { View } from "./types/View";
import { ViewIndex } from "./types/ViewIndex";

export const Views: View = {
    [ViewIndex.COLORS]: {
        title: "Colors",
        component: <ColorDocs />,
    },
    [ViewIndex.TYPOGRAPHY]: {
        title: "Typography",
        component: <TypographyDocs />,
    },
    [ViewIndex.FORMS]: {
        title: "Forms",
        component: <FormManagerDocs />,
    },
    [ViewIndex.INPUTS]: {
        title: "Inputs",
        component: <InputDocs />,
    },
    [ViewIndex.BUTTONS]: {
        title: "Buttons",
        component: <ButtonDocs />,
    },
    [ViewIndex.FORM_FIELDS]: {
        title: "FormField",
        component: <FormFieldDocs />,
    },
    [ViewIndex.TABLES]: {
        title: "Tables",
        component: <TableDocs />,
    },
    [ViewIndex.FORM_PAGE]: {
        title: "Form page",
        component: <FormPageDocs />,
    },
};
